import { fetchApi } from '@/config/axiosSetting';
import { postCulpritRejectOrAcceptParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/postCulpritAcceptOrRejectRecievedImages/postCulpritAcceptOrRejectRecievedImages.type';
import { AxiosResponse } from 'axios';

export const postCulpritAcceptOrRejectReceivedImagesFunction = (
  params: postCulpritRejectOrAcceptParamsType,
): Promise<AxiosResponse<any, any>> => {
  return fetchApi.post(
    `/property/reports/${params.id}/accident_users/culprit/images/corrective/accept_or_reject/`,
    {
      id: params.id,
      ...params.data,
    },
  );
};
